import HeaderAndSidebar from 'components/templates/HeaderAndSidebar';
import { MonthlyTotalAsset } from 'types';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
} from '@mui/material';
import { useState } from 'react';

type Props = {
  isLoading: boolean;
  monthlyTotalAsset: MonthlyTotalAsset | null;
  onUpdate: (monthlyTotalAsset: MonthlyTotalAsset) => void;
};

const EditMonthlyTotalAsset: React.FC<Props> = ({
  isLoading,
  monthlyTotalAsset,
  onUpdate,
}) => {
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const handleChangeYear = (event: SelectChangeEvent) => {
    setYear(event.target.value);
  };
  const [month, setMonth] = useState((new Date().getMonth() + 1).toString());
  const handleChangeMonth = (event: SelectChangeEvent) => {
    setMonth(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const selectedYear = data.get('year');
    const selectedMonth = data.get('month');
    const inputBank = data.get('bank');
    const inputWallet = data.get('wallet');
    if (selectedYear && selectedMonth && inputBank && inputWallet) {
      if (!monthlyTotalAsset) return;

      const updatedMonthlyTotalAsset = {
        id: monthlyTotalAsset.id,
        year: parseInt(selectedYear.toString(), 10),
        month: parseInt(selectedMonth.toString(), 10),
        bank: parseInt(inputBank.toString(), 10),
        wallet: parseInt(inputWallet.toString(), 10),
      };

      onUpdate(updatedMonthlyTotalAsset);
    }
  };

  return (
    <HeaderAndSidebar pageTitle="総資産">
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Grid item xs={12} md={12} lg={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1 }}
            >
              <Stack spacing={3} maxWidth={400}>
                <Select
                  label="年"
                  name="year"
                  value={year}
                  onChange={handleChangeYear}
                  autoWidth
                >
                  {[2021, 2022, 2023, 2024, 2025, 2026].map((y, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <MenuItem key={index} value={y}>
                      {y}
                    </MenuItem>
                  ))}
                </Select>
                <Select
                  label="月"
                  name="month"
                  value={month}
                  onChange={handleChangeMonth}
                  autoWidth
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((y, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <MenuItem key={index} value={y}>
                      {y}
                    </MenuItem>
                  ))}
                </Select>
                <TextField
                  margin="normal"
                  required
                  label="口座残高"
                  name="bank"
                  defaultValue={monthlyTotalAsset?.bank || 0}
                />
                <TextField
                  margin="normal"
                  required
                  label="所持金"
                  name="wallet"
                  defaultValue={monthlyTotalAsset?.wallet || 0}
                />
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ maxWidth: '64px' }}
                >
                  更新
                </Button>
              </Stack>
            </Box>
          </Paper>
        </Grid>
      )}
    </HeaderAndSidebar>
  );
};

export default EditMonthlyTotalAsset;
